import { Component, Input } from '@angular/core';
import { ConstrainedField } from '@app/shared/models/constrained-field';

@Component({
  selector: 'app-textarea-cell',
  template: `
<mat-form-field appearance="outline">
<mat-label>{{ field.key | translate }}</mat-label>
<textarea matInput
          autocomplete="off"
          [formControl]="field.control"
          placeholder="{{ field.key | translate }}"></textarea>
</mat-form-field>
`,
  styleUrls: ['./textarea-cell.component.scss'],
})
export class TextareaCellComponent {
  @Input() public field!: ConstrainedField;
}
